// Background of a dropdown option across the Accounting screens (Sales,
// Purchasing, Finance, Contacts): dark enough that the hovered and the
// selected option stand out clearly. The same values are in Accounting.css for
// the search-type dropdown (.cl-type-dropdown-option).
export const OPTION_HOVER_BG = "#cbd5e1";
export const OPTION_SELECTED_BG = "#bfdbfe";
export const OPTION_SELECTED_HOVER_BG = "#93c5fd";
// Dark blue text on the selected option: the usual accent blue is too light
// to read well on these backgrounds.
export const OPTION_SELECTED_TEXT = "#1e40af";

export const optionBackground = ({ active = false, selected = false }, idle = "transparent") => {
    if (selected) return active ? OPTION_SELECTED_HOVER_BG : OPTION_SELECTED_BG;
    return active ? OPTION_HOVER_BG : idle;
};
